// RedirectComponent.jsx
import { useEffect } from 'react';

const redirectMapping = {
    '/pages/joining-kits': '/employee-recognition/joining-kits',
    '/pages/downlaod-report': '/gifting-report-2024',
    '/pages/sell-with-us' : '/',
    '/pages/brand-stores': '/company-store/brand-store',
    '/pages/brand-stores': '/company-store/brand-store',
    '/pages/corporate-gifting': '/branded-merchandise/corporate-gifting',
    '/pages/experiential-gifting' :'/branded-merchandise/experiential-gifting',
    '/pages/channel-employee-recognitions': '/employee-recognition',
    '/pages/contact-us' :'/contact-us',
    '/pages/about-us' :'/who-we-are/about-eyantra',
    '/pages/our-team' : '/',
    '/pages/quality' : '/',
    '/pages/help-faqs' : '/contact-us',
    '/pages/terms-condition' :'/terms-and-conditions',
    '/pages/privacy-policy' : '/privacy-policy',
    '/pages/return-policy' : '/',
    '/pages/the-corporate-gifting-and-trends-report-2024-25' : '/gifting-report-2024',
};

function RedirectComponent() {
  useEffect(() => {
    const { pathname } = window.location;
    console.log('Current Path:', pathname);

    const targetPath = redirectMapping[pathname];
    console.log('Redirect Target:', targetPath);

    if (targetPath) {
      console.log(`Redirecting to ${targetPath}`);
      window.location.replace(targetPath); 
    }
  }, []);

  return null;
}

export default RedirectComponent;
